import React, { useState, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { ImageUploadStyle } from './Component.style';

import { ReactComponent as Exclamation } from 'assert/images/Common/exclamation.svg';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Notification } from './CustomNotification';

export default function FileUpload({
  disabled,
  label,
  required,
  filesList,
  multiple,
  value,
  errMsg,
  handleFileSRC,
  title,
  isUploadDoc = false,
  resetTrigger,
}) {
  const { t } = useTranslation();
  const [files, setFiles] = useState(value);
  const [dragActive, setDragActive] = useState(false);

  const { getRootProps, getInputProps } = useDropzone({
    minSize: 0,
    maxSize: 8388608,
    disabled,
    // accept: {
    //   'application/*': ['.pdf', ...(isUploadDoc ? ['.doc', '.docx'] : [])],
    // },
    accept: isUploadDoc
      ? {
          'application/pdf': ['.pdf'],
          'application/msword': ['.doc'],
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            ['.docx'],
        }
      : {
          'application/pdf': ['.pdf'],
        },
    onDrop: (acceptedFiles) => {
      const oversized = acceptedFiles.filter((file) => file.size > 8388608); // 8MB in bytes
      if (oversized.length > 0) {
        Notification('warning', 'File size should not exceed 8 MB');
        return;
      }
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
    onDropRejected: () => {
      setDragActive(false);
      Notification(
        'warning',
        isUploadDoc
          ? 'Only PDF, DOC, and DOCX files are supported'
          : 'Only PDF files are supported'
      );
    },
    onDragEnter: () => setDragActive(true),
    onDragLeave: () => setDragActive(false),
  });

  useEffect(() => {
    if (resetTrigger) {
      setFiles([]);
      handleFileSRC([multiple ? [] : null]);
    }
  }, [resetTrigger]);

  useEffect(() => {
    if (multiple) {
      value?.length > 0 && filesList([...value, ...files]);
      return () =>
        files?.length > 0 &&
        files?.forEach((file) => URL.revokeObjectURL(file?.preview));
    } else {
      files?.length > 0 &&
        (multiple ? handleFileSRC([...value, ...files]) : handleFileSRC(files));
    }
  }, [files]);

  const isActive = dragActive;

  return (
    <ImageUploadStyle disabled={disabled}>
      <div className="dropzone-block">
        {label && (
          <div className="lebelView">
            <label>
              {label} {required && <span className="requiredSymbol">*</span>}
            </label>
          </div>
        )}
        <section
          {...getRootProps()}
          className={clsx(
            'dropzoneContainer',
            isActive && 'dropzone-highlight'
          )}
        >
          <div>
            {disabled ? '' : <input {...getInputProps()} multiple={multiple} />}
            {isActive ? (
              <div>Drop here to upload</div>
            ) : (
              <div>
                {files?.[0]?.name ? files?.[0]?.name : title || t('Job.Drag')}
              </div>
            )}
          </div>
        </section>
        {errMsg && (
          <span className="errMsg">
            <Exclamation />
            {errMsg}
          </span>
        )}
      </div>
    </ImageUploadStyle>
  );
}
